export const DATE_SPECIFIC = 'DATE'
export const PERIOD_SPECIFIC = 'PERIOD'
